import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import {
  Modal,
  Input,
  Upload,
  Button,
  Divider,
  message as antMessage
} from 'antd';
import { useTranslation } from 'react-i18next';
import { UploadOutlined } from '@ant-design/icons';
import useErrorMessage from '../../utils/ErrorMessage';
import { routes, subRoutes } from '../../utils/constants/routes';
import useAuthContext from '../../contexts/AuthContext';

const { TextArea } = Input;

const ExemptionModificationModal = ({ ticketId, openModal, setOpenModal }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { message } = useErrorMessage();
  const [file, setFile] = useState([]);
  const [sendComment, setSendComment] = useState('');
  const { dispatchAPI } = useAuthContext();

  const patchTicketStatus = async (id) => {
    try {
      const formData = new FormData();
      const body = {
        sendComment,
        value: "A l'étude",
        status: 'IN_PROGRESS'
      };
      formData.append('values', JSON.stringify(body));
      file.forEach((f) => formData.append('file', f));
      const response = await dispatchAPI('PATCH', {
        url: `tickets/ticketStatus/${id}`,
        body: formData
      });
      if (response.status === 200) {
        antMessage.success(t('tickets.messages.success'));
      }
      navigate({
        pathname: `${routes.QUOTES}${subRoutes.QUOTES.QUOTES_IN_EXEMPTION}`
      });
    } catch (e) {
      if (e.response) message(e.response.status);
    }
  };

  // Function when the modal is closing with OK
  const handleModalSubmit = async () => {
    await patchTicketStatus(ticketId);
    setSendComment();
    setOpenModal(false);
    setFile([]);
  };

  // Function when the modal is closing with CANCEL
  const handleModalClose = () => {
    setSendComment();
    setOpenModal(false);
    setFile([]);
  };

  return (
    <Modal
      title={`
      ${t('settings.tickets.modal.title')}`}
      open={openModal}
      onOk={() => handleModalSubmit()}
      onCancel={() => handleModalClose()}
      width={700}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div>
          <p>{t('settings.tickets.modal.comment')}</p>
          <TextArea
            style={{ width: 450, height: 150 }}
            onChange={(e) => setSendComment(e.target.value)}
          />
        </div>
        <Divider />
        <div>
          <p style={{ fontWeight: 700 }}>
            {t('buttons.upload_ask', { max: 10 })}
          </p>
          <Upload
            maxCount={10}
            beforeUpload={(doc) => {
              const newFile = [...file];
              newFile.push(doc);
              setFile(newFile);
              return false;
            }}
            onRemove={(doc) => {
              const index = file.indexOf(doc);
              const newFile = file.slice();
              newFile.splice(index, 1);
              setFile(newFile);
            }}
          >
            <Button icon={<UploadOutlined />}>{t('buttons.upload')}</Button>
          </Upload>
        </div>
      </div>
    </Modal>
  );
};

ExemptionModificationModal.propTypes = {
  ticketId: PropTypes.string.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  openModal: PropTypes.bool.isRequired
};

export default ExemptionModificationModal;
